import type {EntityType} from 'nutshell-graphql-types';

export const getPeepIdFromSlug = (
    entityType: EntityType | 'person' | 'company',
    peepSlug: string
) => {
    if (entityType === 'ACCOUNT' || entityType === 'company') {
        return `${peepSlug.split('-')[0]}-accounts`;
    }
    return `${peepSlug.split('-')[0]}-contacts`;
};
